@if (stateService.isAuthenticated) {
  @if (!stateService.fullScreen) {
    <mat-drawer-container class="drawer-container" [hasBackdrop]="false">
    <mat-drawer #sidenav mode="side" disableClose="true" [opened]="true" [ngClass]="{'force-drawer-open': forceSideMenuOpen===true, 
                                                                            'menu-collapsed': isMenuOpened===false}">
        <app-menu
          location='side'
          (toggle)="onMenuToggle($event)"
          (forceCloseMenu)="onForceMenuClose()"
          [forceShowMenu]="forceSideMenuOpen"
          [expandCategory]="expandCategory"
          [(selectedMenu)]="selectedMenu"
          (selectedMenuChange)="onMenuChange($event)">
        </app-menu>
      </mat-drawer>
      <mat-drawer-content class="content-container" [ngClass]="{'content-container-expanded': isMenuOpened===false}">
        <app-banner
          [menu]="selectedMenu"
          [user]="user"
          [ismenuopen]="isMenuOpened">
        </app-banner>
        <router-outlet></router-outlet>
        <app-menu
          location='bottom'
          (forceShowMenuChange)="onForceSideMenuOpen($event)"
          [(selectedMenu)]="selectedMenu"
          (selectedMenuChange)="onMenuChange($event)">
        </app-menu>
      </mat-drawer-content>
    </mat-drawer-container>
  }
  @if (stateService.fullScreen) {
    <router-outlet name="fullscreen"></router-outlet>
  }
}